import * as React from 'react';

import { IInfrastructureCell } from '../../../../../../types/newbuildingsCompare';
import { Body1 } from '@cian/ui-kit';
import { infrastructureIconMapper } from './mapper';
import * as styles from './styles.css';

export interface IInfrastructureCellProps {
  cell: IInfrastructureCell;
}

export const InfrastructureCell = ({ cell }: IInfrastructureCellProps): React.JSX.Element => (
  <div className={styles['container']}>
    {cell.data?.infrastructures &&
      cell.data.infrastructures.map((item, index) => {
        return (
          <span className={styles['ifrastracture-row']} key={index}>
            <div className={styles['icon-wrapper']}>{infrastructureIconMapper(item.type)}</div>
            <Body1>{item.text}</Body1>
          </span>
        );
      })}
  </div>
);
